import React, { useState, useEffect } from 'react';
import { Table, Button, Tag } from 'antd';
import { constructColumn, constructColumnFilterSearch } from 'utils/table/table';
import { billingFunctions } from 'utils/constants';

const TableComponent = ({ data, onSelectedProduct, loading, productCategoryData }) => {
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleOnClickEditProduct = product => {
    onSelectedProduct(product);
  };

  const handleFilterChange = (pagination, filters) => {
    setSelectedFilters(filters.functions || []);
  };

  const mapCategoryNames = data => {
    return data.map(record => {
      const category = productCategoryData.find(cat => cat._id === record.category);
      return {
        ...record,
        categoryName: category ? category.name : 'Unknown Category'
      };
    });
  };

  console.log(data);

  const filteredData = selectedFilters.length > 0 ? data.filter(record => selectedFilters.every(filter => record.functions.includes(filter))) : data;
  const filteredMappedData = mapCategoryNames(filteredData);

  const columns = [
    {
      ...constructColumn('Product Name', 'name', { hasSorter: true }),
      ...constructColumnFilterSearch('name', 'Search Product Name'),
      render: (text, record) => {
        return (
          <Button type="link" onClick={() => handleOnClickEditProduct(record)}>
            {text}
          </Button>
        );
      }
    },
    {
      ...constructColumn('Category', 'categoryName', { hasSorter: true }),
      ...constructColumnFilterSearch('categoryName', 'Search Category Name')
    },
    {
      title: 'Billing Functions',
      dataIndex: 'functions',
      key: 'functions',
      filters: billingFunctions.map(cat => ({ text: cat.label, value: cat.value })),
      onFilter: (value, record) => {
        return true; // This will be handled in handleFilterChange
      },
      render: (value, record) => {
        if (record.functions.length > 0) {
          return (
            <div>
              {record.functions.map((func, index) => {
                const category = billingFunctions.find(cat => cat.value === func);
                const tagStyles =
                  category.color === 'yellow'
                    ? { backgroundColor: '#fffebf', borderColor: '#fcfa3a', color: '#d1cf15', marginBottom: '5px' }
                    : { marginBottom: '5px' };
                return category ? (
                  <Tag color={category.color} key={index} style={tagStyles}>
                    {category.label}
                  </Tag>
                ) : null;
              })}
            </div>
          );
        } else {
          return '-';
        }
      }
    },
    {
      ...constructColumn('Description', 'description')
    },
    {
      title: 'Created At',
      dataIndex: 'createdAtWithFormat',
      key: 'createdAtWithFormat',
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt) // Sort by the original date field
    }
  ];

  return <Table dataSource={filteredMappedData} columns={columns} onChange={handleFilterChange} loading={loading} />;
};

export default TableComponent;
